import React from 'react'
import { Link } from 'react-router-dom';
import Container from '../../Container/Container'
import fan from '../../../assets/images/product/banner/banner-fan.webp'
import keyboard from '../../../assets/images/product/banner/banner-keyboard.webp'
import mouse from '../../../assets/images/product/banner/banner-mouse.webp'
import ssd from '../../../assets/images/product/banner/banner-ssd.webp'
function ProductTypesBanner() {
    return (
        <>
            <Container class1=''>
                <section>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex flex-wrap py-sm-5 py-lg-3">
                                <div className=' col-12 col-sm-6  col-md-4 col-lg-3 p-0 p-sm-2'>
                                    <Link to='/store' className=''  >
                                        <figure>
                                            <img src={fan} className='img-fluid bdrs20 pe-lg-2' alt="فن" />
                                        </figure>
                                    </Link>
                                </div>
                                <div className=' col-12 col-sm-6  col-md-4 col-lg-3 p-0 p-sm-2'>
                                    <Link to='/store'  >
                                        <figure>
                                            <img src={keyboard} className='img-fluid bdrs20 pe-lg-2' alt="کیبورد" />
                                        </figure>
                                    </Link>
                                </div>
                                <div className=' col-12 col-sm-6  col-md-4 col-lg-3 p-0 p-sm-2'>
                                    <Link to='/store'  >
                                        <figure>
                                            <img src={mouse} className='img-fluid bdrs20 pe-lg-2' alt="موس" />
                                        </figure>
                                    </Link>
                                </div>
                                <div className=' col-12 col-sm-6  col-md-4 col-lg-3 p-0 p-sm-2'>
                                    <Link to='/store'  >
                                        <figure>
                                            <img src={ssd} className='img-fluid bdrs20 pe-lg-2' alt="اس اس دی" />
                                        </figure>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Container>
        </>
    )
}

export default ProductTypesBanner